import {Hidden,  StyledCheckbox, CheckSVG} from './styles.js';
import {TestingBasicLabel} from '../../../atoms/UI/forms/TestingBasicLabel/styles.js';
import React from 'react'
import {FieldError, FieldErrorsImpl, FieldValues, Merge} from 'react-hook-form'
import TestingAnswerContent from '../TestingAnswerContent/TestingAnswerContent';
import WrongSVG from '../../../atoms/UI/forms/WrongSVG/WrongSVG';
import ErrorMessage from '../../../atoms/UI/forms/ErrorMessage/ErrorMessage';
import { getErrorMessage } from '@/core/utils/errorUtils';


type TestingFormCheckboxType<T> = {
    type?: string | undefined;
    name: string;
    label?: string
    value: boolean
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    error?: string | FieldError | Merge<FieldError, FieldErrorsImpl<any>> | undefined
    imgSrc?: string;
    isCorrect?: boolean | undefined;
    isComment?: boolean;
    commentText?: string
    disabled?: boolean
    required?: boolean
};

export const TestingFormCheckbox = <T extends FieldValues>({
       label,
       onChange,
       value, imgSrc, isCorrect, isComment, disabled, commentText, error
    }: TestingFormCheckboxType<T>)  => {

    const errorMessage = getErrorMessage(error);

    return (
        <TestingBasicLabel isDisabled={disabled} className='checkbox'>
            <Hidden
                checked={value ?? false}
                onChange={onChange}
                disabled={disabled}
            />
            <StyledCheckbox checked={value}>
                {value && (
                    typeof isCorrect !== 'undefined'
                        ? (
                            isCorrect
                            ? <CheckSVG
                                    rightAnswer={isCorrect}
                                    viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M16.667,62.167c3.109,5.55,7.217,10.591,10.926,15.75 c2.614,3.636,5.149,7.519,8.161,10.853c-0.046-0.051,1.959,2.414,2.692,2.343c0.895-0.088,6.958-8.511,6.014-7.3 c5.997-7.695,11.68-15.463,16.931-23.696c6.393-10.025,12.235-20.373,18.104-30.707C82.004,24.988,84.802,20.601,87,16"/>
                                </CheckSVG>
                            : <WrongSVG />
                        ) :
                        <CheckSVG
                            viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                            <path d="M16.667,62.167c3.109,5.55,7.217,10.591,10.926,15.75 c2.614,3.636,5.149,7.519,8.161,10.853c-0.046-0.051,1.959,2.414,2.692,2.343c0.895-0.088,6.958-8.511,6.014-7.3 c5.997-7.695,11.68-15.463,16.931-23.696c6.393-10.025,12.235-20.373,18.104-30.707C82.004,24.988,84.802,20.601,87,16"/>
                        </CheckSVG>
                    )
                }
            </StyledCheckbox>

            <TestingAnswerContent
                imgSrc={imgSrc}
                label={label}
                isComment={isComment}
                commentText={commentText}
                isCorrect={isCorrect}
                isSelected={value}
                isDisabled={disabled}
            />
            {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
        </TestingBasicLabel>
    )
}

export default TestingFormCheckbox;

